module.exports = __webpack_public_path__ + "static/brian-rogers-b48f0885964e05c5ef2920260c278475.png";